var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5082ef",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#5082ef",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5082ef",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5a5a66"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ab",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5082ef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow-p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c6cf0",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#7c6cf0",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c6cf0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow-t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2f9e8f",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2f9e8f",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2f9e8f",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 99.7,
    y1: 110.8,
    x2: 216.1,
    y2: 102.1,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100.7,
    y1: 64.7,
    x2: 148.5,
    y2: 180.2,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.45
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 127.9,
    y1: 87.5,
    x2: 99.7,
    y2: 110.8,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 99.7,
    y1: 110.8,
    x2: 79.9,
    y2: 87.9,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 79.9,
    y1: 87.9,
    x2: 100.7,
    y2: 64.7,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 127.9,
    y1: 87.5,
    x2: 79.9,
    y2: 87.9,
    stroke: "#5082ef",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 236.5,
    y1: 87,
    x2: 216.1,
    y2: 102.1,
    stroke: "#7c6cf0",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 216.1,
    y1: 102.1,
    x2: 213,
    y2: 72.4,
    stroke: "#7c6cf0",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 213,
    y1: 72.4,
    x2: 236.5,
    y2: 87,
    stroke: "#7c6cf0",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 175.2,
    y1: 168.5,
    x2: 148.5,
    y2: 180.2,
    stroke: "#2f9e8f",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 148.5,
    y1: 180.2,
    x2: 149.9,
    y2: 151.4,
    stroke: "#2f9e8f",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 149.9,
    y1: 151.4,
    x2: 175.2,
    y2: 168.5,
    stroke: "#2f9e8f",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 87.7,
    r: 34,
    fill: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.9,
    cy: 87.2,
    r: 34,
    fill: "url(#glow-p)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.9,
    cy: 166.7,
    r: 34,
    fill: "url(#glow-t)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.9,
    cy: 87.5,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.7,
    cy: 110.8,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.9,
    cy: 87.9,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.7,
    cy: 64.7,
    r: 7,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.5,
    cy: 87,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.1,
    cy: 102.1,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 72.4,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.2,
    cy: 168.5,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 180.2,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.9,
    cy: 151.4,
    r: 7,
    fill: "#2f9e8f",
    stroke: "#2f9e8f",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunities);
export default __webpack_public_path__ + "static/media/communities.783c0c38fa6092d3d4f974a35fc2e7f7.svg";
export { ForwardRef as ReactComponent };